/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { useDelayedHover } from "hooks/discovery";
import ProgressBar from "components/ProgressBar";
import ActionButtons from "layout/discovery/ActionButtons";
import { ACTION_BUTTONS_WIDTH, PLACEMENTS } from "constants/discovery";
import { setByContentHoveredTerm } from "slices/discovery/discoverySlice";
import Ellipsis from "components/Ellipsis";
import { compareStringsCaseInsensitive } from "utils";

const MAX_WIDTH = 184; // max width of term text

const ItemsFoundTerm = ({ freq, maxFreq, legend }) => {
  const dispatch = useDispatch();
  const legendRef = useRef();
  const byContentHoveredTerm = useSelector(
    (state) => state.discovery.config.byContentHoveredTerm
  );

  const { hovered, handleMouseOver, handleMouseOut } = useDelayedHover({
    onMouseOver: () => {
      legendRef.current.style.maxWidth = `${MAX_WIDTH - ACTION_BUTTONS_WIDTH}px`;
      dispatch(setByContentHoveredTerm(legend));
    },
    onMouseOut: () => {
      legendRef.current.style.maxWidth = `${MAX_WIDTH}px`;
      dispatch(setByContentHoveredTerm(null));
    },
  });

  return (
    <span className="by_content__body__row__item_found">
      <ProgressBar current={freq} max={maxFreq} width="85px" height="5px" />
      <span className="by_content__body__row__item_found__freq">{freq}</span>
      <span
        className="by_content__body__row__item_found__legend"
        data-testid="legend"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <div
          ref={legendRef}
          className="by_content__body__row__item_found__legend__text_wrapper"
        >
          <Ellipsis
            text={legend}
            classes={clsx({
              highlighted: compareStringsCaseInsensitive(
                legend,
                byContentHoveredTerm
              ),
            })}
          />
        </div>
        {hovered && (
          <ActionButtons
            term={legend}
            terms={[legend]}
            placement={PLACEMENTS.RIGHT}
            parentRef={legendRef}
            alignBottom
          />
        )}
      </span>
    </span>
  );
};

ItemsFoundTerm.propTypes = {
  freq: PropTypes.number.isRequired,
  maxFreq: PropTypes.number.isRequired,
  legend: PropTypes.string.isRequired,
};

export default React.memo(ItemsFoundTerm);
